module.exports = __webpack_public_path__ + "b631f36b555acf9c992c801c3ac570b1.pdf";